import * as React from "react";
import type { SVGProps } from "react";
const SvgStarHalfFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#star-half-fill_svg__a)">
      <path d="M17.28 22a1.82 1.82 0 0 1-1.06-.35L12 18.58l-4.22 3.07a1.8 1.8 0 0 1-2.14 0 1.72 1.72 0 0 1-.62-2l1.8-5.22-4-2.59a1.75 1.75 0 0 1-.74-2 1.78 1.78 0 0 1 1.71-1.22h4.65l1.87-5.42a1.79 1.79 0 0 1 3.38 0l1.87 5.42h4.65a1.78 1.78 0 0 1 1.72 1.27 1.75 1.75 0 0 1-.74 2l-4 2.59L19 19.67a1.72 1.72 0 0 1-.62 2 1.8 1.8 0 0 1-1.1.33M4.58 10.62l3.48 2.25a1.75 1.75 0 0 1 .71 2l-1.62 4.77 3.79-2.76a1.8 1.8 0 0 1 2.12 0l3.79 2.76-1.62-4.72a1.76 1.76 0 0 1 .71-2.05l3.48-2.25h-4a1.79 1.79 0 0 1-1.69-1.19L12 4.42l-1.72 5a1.79 1.79 0 0 1-1.69 1.19z" />
      <path d="M12 3.13v14.41L7 21l-1.03-1.01 2.04-5.66L3 10.66l.52-.99 5.62-.27z" />
    </g>
    <defs>
      <clipPath id="star-half-fill_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStarHalfFill;
